import styled from "@emotion/styled";
import React from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Home from "./components/Home";
import Order from "./components/Order";
import OrderLog from "./components/OrderLog";
import Reservation from "./components/Reservation";
import Member from "./components/Member";
import Coupon from "./components/Coupon";
import CouponLog from "./components/CouponLog";
import Item from "./components/Item";
import Point from "./components/Point";
import PointLog from "./components/PointLog";
import Push from "./components/Push";
import Dcoupon from "./components/Dcoupon"; // 할인쿠폰
import DcouponIssue from "./components/DcouponIssue"; // 할인쿠폰 발행
import CenterOpen from "./components/CenterOpen";
import SmartKey from "./components/SmartKey";
import ReservationLog from "./components/ReservationLog";
import Refund from "./components/Refund";
import Test from "./components/Test"; // TEST
import PosCoupon from "./components/PosCoupon"; // 쿠폰매출 달력
import Return from "./components/Return"; // 쿠폰반환신청
import Frequency from "./components/Frequency";
import Gift from "./components/Gift";
import Teacher from "./components/Teacher";
import Resume from "./components/Resume";
import ChartClass from "./components/ChartClass";
import ChartClassWeekly from "./components/ChartClassWeekly";
import Review from "./components/Review"; // 리뷰이벤트
import PosCard from "./components/PosCard"; // 카드매출 달력
import ReportCard from "./components/ReportCard"; // 카드매출 달력
import ReportCoupon from "./components/ReportCoupon"; // 쿠폰매출 달력
import BaseCode from "./components/BaseCode"; // 기초코드
import ReportMarketing from "./components/ReportMarketing";
import ReportMarketingQuestion from "./components/ReportMarketingQuestion";
import Board from "./components/board/index";
import ReportFc from "./components/ReportFc";
import WhatsNew from "./components/WhatsNew";

const MainContainer = styled.div``;

function App() {
  return (
    <MainContainer className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/order" element={<Order />} />
        <Route path="/order_log" element={<OrderLog />} />
        <Route path="/reservation" element={<Reservation />} />
        <Route path="/member" element={<Member />} />
        <Route path="/coupon" element={<Coupon />} />
        <Route path="/coupon_log" element={<CouponLog />} />
        <Route path="/item" element={<Item />} />
        <Route path="/point" element={<Point />} />
        <Route path="/point_log" element={<PointLog />} />
        <Route path="/push" element={<Push />} />
        <Route path="/dcoupon" element={<Dcoupon />} />
        <Route path="/dcoupon_issue" element={<DcouponIssue />} />
        <Route path="/center_open" element={<CenterOpen />} />
        <Route path="/smart_key" element={<SmartKey />} />
        <Route path="/reservation_log" element={<ReservationLog />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/pos_coupon" element={<PosCoupon />} />
        <Route path="/return" element={<Return />} />
        <Route path="/frequency" element={<Frequency />} />
        <Route path="/gift" element={<Gift />} />
        <Route path="/test" element={<Test />} />
        <Route path="/teacher" element={<Teacher />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/chart_class" element={<ChartClass />} />
        <Route path="/chart_class_weekly" element={<ChartClassWeekly />} />
        <Route path="/review" element={<Review />} />
        <Route path="/pos_card" element={<PosCard />} />
        <Route path="/report_card" element={<ReportCard />} />
        <Route path="/report_coupon" element={<ReportCoupon />} />
        <Route path="/basecode" element={<BaseCode />} />
        <Route path="/report_marketing" element={<ReportMarketing />} />
        <Route path="/report_fc" element={<ReportFc />} />
        <Route
          path="/report_marketing_question"
          element={<ReportMarketingQuestion />}
        />
        <Route path="/board" element={<Board />} />
        <Route path="/whatsnew" element={<WhatsNew />} />
      </Routes>
    </MainContainer>
  );
}

export default App;
